import { getContainerTypes } from "@sellar-io/common";
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { getItemImage } from "./ItemTypeImage.shared";

export function ItemTypeImage({
  product,
  size = "large",
  withoutBackground = false,
}: {
  product: { containerType?: string | null; type: string | null };
  size?: "small" | "large";
  withoutBackground?: boolean;
}) {
  const productContainerTypes = useMemo(
    () => getContainerTypes(product.containerType ?? undefined),
    [product.containerType],
  );

  const imageSrc = useMemo(() => {
    if (product.type === "badge") return getItemImage("badge");
    if (productContainerTypes.includes("keg")) return getItemImage("keg");
    if (productContainerTypes.includes("cask")) return getItemImage("cask");
    if (productContainerTypes.includes("can")) return getItemImage("can");
    if (productContainerTypes.includes("bottle")) return getItemImage("bottle");
    if (productContainerTypes.includes("snack")) return getItemImage("snack");
    if (productContainerTypes.includes("beverage"))
      return getItemImage("badge");
    return undefined;
  }, [product.type, productContainerTypes]);

  if (!imageSrc) return null;

  const image = (
    <img
      className={size === "large" ? "h-7" : "h-5"}
      src={imageSrc}
      alt={product.type ?? undefined}
    />
  );

  return withoutBackground ? (
    image
  ) : (
    <div
      className={twMerge(
        "flex shrink-0 items-center justify-center rounded-lg bg-zinc-100",
        size === "large" ? "h-12 w-12" : "h-8 w-8",
      )}
    >
      {image}
    </div>
  );
}
